import {ErrorAlert} from '@source/components';
import React from 'react';

const NotFoundPage: React.FC = () => <ErrorAlert message={'404'} description={'Page has not been found, try another one'} />;

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage/NotFoundPage.tsx